import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2Icon, DumbbellIcon } from 'lucide-react';
export function BenefitsSection() {
  const mainItems = ['📋 Base Técnica de 140 Ejercicios Analizados', '✅ Checklists de ejecución por ejercicio', '🧠 Análisis muscular y articular completo', '⚠️ Errores frecuentes y cómo corregirlos', '📐 Clasificación funcional por movimiento'];
  const detailsCol1 = ['Músculos agonistas y sinergistas', 'Articulaciones involucradas', 'Errores frecuentes'];
  const detailsCol2 = ['Plano anatómico', 'Ejecución correcta paso a paso', 'Clasificación funcional'];
  return <section className="py-12 bg-background-dark border-y border-card-border-dark" data-id="element-8">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-9">
        <FadeIn className="text-center mb-8" data-id="element-10">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white font-heading mb-2" data-id="element-11">
            Lo que
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-black text-primary font-heading" data-id="element-12">
            recibís:
          </h3>
        </FadeIn>

        <FadeIn delay={0.2} className="mb-8" data-id="element-13">
          <div className="bg-card-dark border-2 border-primary rounded-3xl p-6 md:p-10 shadow-[0_0_30px_rgba(255,107,0,0.15)]" data-id="element-14">
            <div className="flex items-center gap-4 mb-4" data-id="element-15">
              <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center shrink-0" data-id="element-16">
                <DumbbellIcon className="w-6 h-6 text-primary" data-id="element-17" />
              </div>
              <h4 className="text-2xl md:text-3xl font-black text-primary font-heading" data-id="element-18">
                PACK BASES DEL ENTRENAMIENTO DE FUERZA
              </h4>
            </div>

            <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-19">
              +140 ejercicios analizados en profundidad. Todo organizado y listo
              para usar desde hoy.
            </p>

            <ul className="space-y-4" data-id="element-20">
              {mainItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-21">
                  <span className="text-white text-lg md:text-xl font-medium leading-relaxed" data-id="element-22">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="mb-10" data-id="element-23">
          <div className="bg-card-dark border border-primary rounded-3xl p-6 md:p-8" data-id="element-24">
            <h4 className="text-xl md:text-2xl font-black text-primary font-heading text-center mb-8" data-id="element-25">
              Cada ejercicio incluye:
            </h4>

            <div className="grid md:grid-cols-2 gap-4 md:gap-8" data-id="element-26">
              <ul className="space-y-4" data-id="element-27">
                {detailsCol1.map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-28">
                    <CheckCircle2Icon className="w-6 h-6 text-success shrink-0" data-id="element-29" />
                    <span className="text-white text-lg" data-id="element-30">{item}</span>
                  </li>)}
              </ul>
              <ul className="space-y-4" data-id="element-31">
                {detailsCol2.map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-32">
                    <CheckCircle2Icon className="w-6 h-6 text-success shrink-0" data-id="element-33" />
                    <span className="text-white text-lg" data-id="element-34">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.6} className="text-center max-w-3xl mx-auto" data-id="element-35">
          <h4 className="text-2xl font-bold text-white mb-4" data-id="element-36">
            ¿Por qué funciona en cualquier contexto profesional?
          </h4>
          <p className="text-gray-400 italic leading-relaxed" data-id="element-37">
            Con terminología aplicable en cualquier sistema de entrenamiento.
            Desde Buenos Aires hasta Córdoba, desde Rosario hasta Mendoza. Este
            material fue creado para vos, donde sea que trabajes.
          </p>
        </FadeIn>
      </div>
    </section>;
}